// Network Design Service - handles CRUD operations for network flow configurations

import axiosInstance from "../axiosInstance";

export const networkDesignService = {
  // Create a new network design configuration
  create: async (obj) => {
    try {
      const response = await axiosInstance.post("/network-design", obj);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Fetch network designs with optional filters
  fetch: async (searchValue, query, clientId) => {
    try {
      let apiQuery = `/network-design?$populate=client`;
      if (searchValue) apiQuery += `&name[$search]=${searchValue}`;
      if (query && query.length) apiQuery += `&${query}`;
      if (clientId) apiQuery += `&client=${clientId}`;
      const response = await axiosInstance.get(apiQuery);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Fetch a single network design by ID
  fetchById: async (id) => {
    try {
      const response = await axiosInstance.get(`/network-design/${id}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Fetch network design for a specific client
  fetchByClient: async (clientId) => {
    try {
      const response = await axiosInstance.get(
        `/network-design?client=${clientId}`
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Update an existing network design
  edit: async (id, obj) => {
    try {
      const response = await axiosInstance.patch(`/network-design/${id}`, obj);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Delete a network design
  delete: async (id) => {
    try {
      const response = await axiosInstance.delete(`/network-design/${id}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Get all available node types
  fetchNodeTypes: async () => {
    try {
      const response = await axiosInstance.get("/network-design/node-types");
      return response.data;
    } catch (error) {
      throw error;
    }
  },
};
